import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-6 sm:p-8" }
const _hoisted_2 = { class: "flex items-center justify-between mb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-[#6CC551] text-xs font-bold uppercase tracking-widest mb-1" }, "Departments"),
  /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-extrabold text-[#1E2833]" }, "View Departments")
], -1)
const _hoisted_4 = { class: "mb-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "dept-filter",
  class: "block mb-1.5 text-xs font-semibold",
  style: {"color":"#4b5563"}
}, "Filter by type", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "Select Category", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", null, "DEPARTMENTS", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", null, "UNITS", -1)
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  class: "bg-white rounded-2xl overflow-hidden mb-5",
  style: {"border":"1px solid #f3f4f6"}
}
const _hoisted_11 = {
  key: 0,
  class: "flex justify-center py-16"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 rounded-full border-4 border-[#6CC551] border-t-transparent animate-spin" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "w-full text-sm text-left"
}
const _hoisted_15 = {
  class: "text-xs text-[#1E2833] uppercase bg-[#6CC551]/10",
  style: {"border-bottom":"1px solid #f3f4f6"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "#", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "Title", -1)
const _hoisted_18 = {
  key: 0,
  class: "px-6 py-3"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "Edit", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "Delete", -1)
const _hoisted_21 = {
  class: "px-6 py-4",
  style: {"color":"#6b7280"}
}
const _hoisted_22 = {
  class: "px-6 py-4 font-medium",
  style: {"color":"#111827"}
}
const _hoisted_23 = {
  key: 0,
  class: "px-6 py-4",
  style: {"color":"#6b7280"}
}
const _hoisted_24 = { class: "px-6 py-4" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "px-6 py-4" }
const _hoisted_27 = ["onClick"]

import { ref, watch } from 'vue';
import Pagination from '@/components/Pagination.vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import { url } from '@/functions/endpoint';
import DeleteModal from "@/components/DeleteModal.vue";
import SuccessMessage from "@/components/SuccessMessage.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import EmptyState from "@/components/EmptyState.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewDepartments',
  setup(__props) {

let count = ref(0);
const postId = ref();
const router = useRouter();
let successMessage = ref('');
let showSuccessMessage = ref(false);
const loading = ref(false);
let errorAlert = ref(false);
let errorMessage = ref('');
let emptyState = ref(false);
const perPage = ref(12);
const currentPage = ref(1);
const category = ref<string>("DEPARTMENTS");

const calculatePostNumber = (index: number) => {
  return (currentPage.value - 1) * perPage.value + index + 1;
};

const editDepartment = (departmentId: number) => {
  category.value === 'DEPARTMENTS'
    ? router.push({ name: 'EditDepartment', params: { id: departmentId } })
    : router.push({ name: 'EditUnit', params: { id: departmentId } });
};

const deleteModal = ref(false);
const openDeleteModal = (id: number) => {
  postId.value = id;
  deleteModal.value = true;
};

const closeDeleteModal = () => {
  deleteModal.value = false;
};

const deleteDocument = async () => {
  try {
    const response = await axios.delete(
      category.value === 'DEPARTMENTS'
        ? `${url}/departments/delete/${postId.value}`
        : `${url}/unit/delete/${postId.value}`
    );

    deleteModal.value = false;
    successMessage.value = response.data?.message ?? 'Deleted successfully';
    showSuccessMessage.value = true;

    const deletedIndex = allDepartments.value.findIndex((item: any) => item.id === postId.value);
    if (deletedIndex !== -1) allDepartments.value.splice(deletedIndex, 1);
    if (allDepartments.value.length === 0) emptyState.value = true;

    setTimeout(() => { showSuccessMessage.value = false; }, 2000);
  } catch (error: any) {
    deleteModal.value = false;
    errorAlert.value = true;
    errorMessage.value = error.message;
    setTimeout(() => { errorAlert.value = false; }, 2500);
  }
};

const allDepartments: any = ref([]);

const fetchNewsItems = () => {
  loading.value = true;
  emptyState.value = false;

  const endpoint = category.value === 'DEPARTMENTS' ? `${url}/departments` : `${url}/unit`;

  axios.get(endpoint, { params: { page: currentPage.value, limit: perPage.value } })
    .then((response: any) => {
      if (category.value === 'DEPARTMENTS') {
        allDepartments.value = Array.isArray(response.data) ? response.data : [];
        count.value = allDepartments.value.length;
      } else {
        allDepartments.value = Array.isArray(response.data[1]) ? response.data[1] : [];
        count.value = response.data[0]?.totalLength ?? 0;
      }
      emptyState.value = allDepartments.value.length === 0;
    })
    .catch((error: any) => {
      console.error(error);
      allDepartments.value = [];
      emptyState.value = true;
    })
    .finally(() => {
      loading.value = false;
    });
};

const onCategoryChange = () => {
  currentPage.value = 1;
  fetchNewsItems();
};

watch(currentPage, fetchNewsItems);
fetchNewsItems();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_router_link, {
          to: "/admin/add-department",
          class: "inline-flex items-center gap-2 px-4 py-2 bg-[#6CC551] hover:bg-green-600 text-white text-sm font-semibold rounded-xl transition-colors"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" + Add Department ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("select", {
          id: "dept-filter",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((category).value = $event)),
          onChange: onCategoryChange,
          class: "w-56 px-4 py-2.5 text-sm rounded-xl focus:outline-none focus:ring-2 focus:ring-[#6CC551]/30 focus:border-[#6CC551] transition-colors",
          style: {"background":"#fff","border":"1px solid #e5e7eb","color":"#111827"}
        }, _hoisted_9, 544), [
          [_vModelSelect, category.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
          : (_openBlock(), _createElementBlock("table", _hoisted_14, [
              _createElementVNode("thead", _hoisted_15, [
                _createElementVNode("tr", null, [
                  _hoisted_16,
                  _hoisted_17,
                  (category.value === 'UNITS')
                    ? (_openBlock(), _createElementBlock("th", _hoisted_18, "Department"))
                    : _createCommentVNode("", true),
                  _hoisted_19,
                  _hoisted_20
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allDepartments.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id,
                    class: "transition-colors",
                    style: {"border-bottom":"1px solid #f9fafb"},
                    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (($event.currentTarget as HTMLElement).style.background='#f9fafb')),
                    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (($event.currentTarget as HTMLElement).style.background=''))
                  }, [
                    _createElementVNode("td", _hoisted_21, _toDisplayString(calculatePostNumber(index)), 1),
                    _createElementVNode("td", _hoisted_22, _toDisplayString(category.value === "DEPARTMENTS" ? item?.name?.slice(0, 80) : item?.title?.slice(0, 80)), 1),
                    (category.value === 'UNITS')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(item?.departmentId), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", _hoisted_24, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (editDepartment(item.id)),
                        class: "text-xs font-semibold text-blue-500 hover:underline"
                      }, "Edit", 8, _hoisted_25)
                    ]),
                    _createElementVNode("td", _hoisted_26, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (openDeleteModal(item.id)),
                        class: "text-xs font-semibold text-red-500 hover:underline"
                      }, "Delete", 8, _hoisted_27)
                    ])
                  ], 32))
                }), 128))
              ])
            ])),
        _createVNode(EmptyState, { showEmptyState: _unref(emptyState) }, null, 8, ["showEmptyState"])
      ]),
      _createVNode(Pagination, {
        modelValue: currentPage.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentPage).value = $event)),
        "per-page": perPage.value,
        "total-items": _unref(count)
      }, null, 8, ["modelValue", "per-page", "total-items"])
    ]),
    (deleteModal.value)
      ? (_openBlock(), _createBlock(DeleteModal, {
          key: 0,
          onDeletePost: deleteDocument,
          onCloseDeleteModal: closeDeleteModal,
          item: 'department'
        }))
      : _createCommentVNode("", true),
    _createVNode(SuccessMessage, {
      showSuccessMessage: _unref(showSuccessMessage),
      successMessage: _unref(successMessage)
    }, null, 8, ["showSuccessMessage", "successMessage"]),
    _createVNode(ErrorMessage, {
      errorAlert: _unref(errorAlert),
      errorMessage: _unref(errorMessage)
    }, null, 8, ["errorAlert", "errorMessage"])
  ], 64))
}
}

})